import { DatePipe } from '@angular/common';
import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AtendimentoDetalhesModel } from '../../../shared/model/atendimento/atendimento-detalhes.model';
import { AvatarPessoaComponent } from '../../../shared/components/redesign/avatar-pessoa/avatar-pessoa.component';
import { CelularMaskPipe } from '../../../shared/pipe/celular-mask.pipe';
import { AtendimentoService } from '../../../shared/service/atendimento.service';
import { MethodsUtils } from '../../../shared/util/methods.utils';
import { ModalAtendimentoData } from './models/modal-atendimento-data.model';
import { ArrastarFecharSheetDirective } from '../../utils/arrastar-fechar-sheet.directive';

@Component({
  selector: 'app-modal-atendimento',
  standalone: true,
  imports: [DatePipe, CelularMaskPipe, ArrastarFecharSheetDirective, AvatarPessoaComponent],
  templateUrl: './modal-atendimento.component.html',
  styleUrls: ['../balao-mensagem/modal-info-mensagem/modal-info-mensagem.component.css', './modal-atendimento.component.css']
})
export class ModalAtendimentoComponent implements OnInit {
  private readonly data = inject<ModalAtendimentoData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<ModalAtendimentoComponent>);
  private readonly atendimentoService = inject(AtendimentoService);

  readonly atendimentoId = this.data.atendimentoId;
  carregando = signal(true);
  erro = signal(false);
  detalhes = signal<AtendimentoDetalhesModel | null>(null);

  readonly duracao = computed(() => {
    const d = this.detalhes();
    if (!d?.dataCriacao) return '-';
    const fim = d.dataFim ? new Date(d.dataFim).getTime() : Date.now();
    return MethodsUtils.formatarDuracao(fim - new Date(d.dataCriacao).getTime());
  });

  ngOnInit(): void {
    this.atendimentoService.buscarDetalhes(this.atendimentoId).subscribe({
      next: res => {
        this.detalhes.set(res ?? null);
        this.carregando.set(false);
      },
      error: () => {
        this.erro.set(true);
        this.carregando.set(false);
      }
    });
  }

  fechar(): void {
    this.dialogRef.close();
  }
}
